export const PXFormsV2 = (function() {
	'use strict';

	let $v2Forms;

	function init() {
		events();
	}

	function renderFormV2() {
		$v2Forms = $('.pxblock--forms-v2.gravity-forms');
		$v2Forms.each( function() {
			let $this = $(this);
			let $container = $this.find('.pxblock--forms-v2__container');
			let $textInputs = $this.find('input[type=text]:not(.datepicker), input[type=email], input[type=url], input[type=tel]');
			let $dateInputs = $this.find('input.datepicker');
			let $checkboxInputs = $this.find('.gfield_checkbox');
			let $textAreaInputs = $this.find('.textarea');
			let $fileInputs = $this.find('.ginput_container_fileupload');
			let $descriptions = $this.find('.gfield_description');
			let icon = PXConstants.theme_directory + '/assets/svg/question.svg';

			if($descriptions.length > 0){
				$descriptions.each(function(){
					let $description = $(this);
					// console.log($description);
					$description.wrap(function(){
						return '<div class="gfield_description__icon-group"></div>';
					}).parent().append( '<img alt="' + $(this).text() +'" src=' + icon + ' />');
				})
			}

			// File Input
			if($fileInputs.length > 0){
				$fileInputs.each(function(){
					let $fileInput = $(this);
					$fileInput
						.append('<div class="pxblock--forms-v2__attach-file"><div class="pxblock--forms-v2__attach-file-text">No file selected...</div><input type="button" value="Select File"/></div>')
						.closest('.gfield').addClass('pxblock--forms-v2__file')
						.find('input[type=file]').bind('change', function() {
							let fileName = this.files[0].name;
							$fileInput.find('.pxblock--forms-v2__attach-file-text').text(fileName);		
						});
				})
			}

			// Text
			$textInputs.closest('.gfield').addClass('pxblock--forms-v2__text');
			
			// Date
			$dateInputs.closest('.gfield').addClass('pxblock--forms-v2__date');

			// Checkbox
			$checkboxInputs.closest('.gfield').addClass('pxblock--forms-v2__checkboxes');

			// Textarea
			$textAreaInputs.closest('.gfield').addClass('pxblock--forms-v2__textarea');

			// Loaded
			$this.find('.gfield').addClass('pxblock--forms-v2__loaded');

		});
	}

	function events() {
		$(document).bind('gform_post_render', function(){
			renderFormV2();
		});
	}

	return {
		init: init
	};
})();
